import { render } from "./tw-backtop.vue?vue&type=template&id=76dc475a"
import script from "./tw-backtop.vue?vue&type=script&lang=js"
export * from "./tw-backtop.vue?vue&type=script&lang=js"
script.render = render

export default script